<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">OTPREMNICE</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <dx-button
          class="btn_trazi"
          [disabled]="disableGumb"
          stylingMode="contained"
          text="Prikaži"
          type="success"
          [width]="120"
          (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>

    <div class="customTable pregledIzdatnica">
      <dx-data-grid
        id="tablicaOtpremnica"
        #tablicaOtpremnica
        [dataSource]="otpremnice"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="pz_id"
        [showBorders]="false"
        [showColumnLines]="true"
        [columnAutoWidth]="true"
        [columnMinWidth]="80"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onEditingStart)="onEditingStart($event)"
        (onInitNewRow)="onInitNewRow($event)"
        (onRowInserted)="dodajOtpremnicu($event)"
        (onRowRemoved)="obrisiOtpremnicu($event)"
        (onRowUpdated)="urediOtpremnicu($event)"
        (onRowClick)="onRowClick($event)"
        (onCellPrepared)="onCellPrepared($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Otpremnice</h2>
            <p class="mt-0">Kliknite na otpremnicu za prikaz detalja</p>
          </div>
        </div>

        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxo-editing
          mode="popup"
          [allowAdding]="true"
          [allowUpdating]="true"
          [allowDeleting]="true"
        >
          <dxo-popup
            [disabled]="pravaZaTrenutniPogled != 2"
            [showTitle]="true"
            title="Otpremnica"
            [maxWidth]="500"
            [height]="'auto'"
          >
          </dxo-popup>

          <dxo-form [colCount]="1">
            <dxi-item
              dataField="pz_datum"
              editorType="dxDateBox"
              [editorOptions]="{ showClearButton: 'true' }"
            ></dxi-item>

            <dxi-item
              dataField="poslovnica_po_id"
              editorType="dxSelectBox"
              [editorOptions]="{
                items: poslovnicePekar,
                value: 'idposlovnica',
                valueExpr: 'idposlovnica',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['po_sifra', 'po_naziv'],
                onItemClick: poslovnicaOdabrana
              }"
            ></dxi-item>

            <dxi-item
              dataField="partner_pa_id"
              editorType="dxSelectBox"
              [editorOptions]="{
                items: partneri,
                value: 'pa_id',
                valueExpr: 'pa_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pa_sifra', 'pa_naziv'],
                onItemClick: partnerOdabran
              }"
            ></dxi-item>

            <dxi-item
              dataField="poslovnicapartnera_pp_id"
              editorType="dxSelectBox"
              [editorOptions]="{
                items: poslovnicePartneraFilter,
                value: 'poslovnicaPartnera_id',
                valueExpr: 'pp_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pp_sifra', 'pp_naziv'],
                onItemClick: poslovnicaPartneraOdabrana
              }"
            ></dxi-item>

            <dxi-item
              dataField="partner_pa_id_vezni"
              editorType="dxSelectBox"
              [editorOptions]="{
                items: prijevoznici,
                value: 'partner_pa_id_vezni',
                valueExpr: 'pa_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pa_sifra', 'pa_naziv']
              }"
            ></dxi-item>

            <dxi-item dataField="pz_registracijavozila"></dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxi-column
          dataField="pz_broj"
          caption="Broj otpremnice"
          [width]="100"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>

        <dxi-column
          caption="Povezani dokumenti"
          cellTemplate="cellLink"
          [width]="100"
          alignment="center"
        >
          <div *dxTemplate="let data of 'cellLink'">
            <dx-button
              hint="Povezani dokumenti"
              icon="link"
              (onClick)="povezaniDokumenti(data)"
            ></dx-button>
          </div>
        </dxi-column>

        <dxi-column
          dataField="pz_datum"
          dataType="date"
          caption="Datum"
          [width]="105"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="broj_dostavnice"
          caption="Broj dostavnice"
          [width]="100"
          alignment="center"
          [allowFiltering]="false"
          [allowEditing]="false"
          cellTemplate="linkTemplate"
        >
          <div *dxTemplate="let cell of 'linkTemplate'">
            <a href="{{ '#/dostavnice' }}" (click)="klikToLink(cell)">{{
              cell.data.broj_dostavnice
            }}</a>
          </div>
        </dxi-column>

        <dxi-column
          dataField="fi_NAZIV"
          caption="Firma"
          [width]="100"
        ></dxi-column>

        <dxi-column
          dataField="poslovnica_po_id"
          caption="Skladište otpreme"
          [visible]="false"
        ></dxi-column>

        <dxi-column
          dataField="po_naziv"
          caption="Skladište otpreme"
          [minWidth]="240"
        ></dxi-column>

        <dxi-column
          dataField="partner_pa_id"
          caption="Kupac"
          [visible]="false"
        ></dxi-column>

        <dxi-column dataField="pa_naziv" caption="Kupac"></dxi-column>

        <dxi-column
          dataField="poslovnicapartnera_pp_id"
          caption="Poslovnica kupca"
          [visible]="false"
        ></dxi-column>

        <dxi-column
          dataField="pp_naziv"
          caption="Poslovnica kupca"
        ></dxi-column>

        <dxi-column
          dataField="name"
          caption="Kreirao"
        ></dxi-column>

        <dxi-column
          dataField="pz_danisat"
          dataType="datetime"
          caption="Datum i vrijeme kreiranja"
          [width]="130"
          alignment="left"
        ></dxi-column>
        
        <dxi-column
          dataField="pz_iznos"
          caption="Iznos"
          format="#,##0.## €"
          alignment="right"
          [width]="140">
        </dxi-column>

        <dxi-column
          dataField="pz_porez"
          caption="Porez"
          format="#,##0.## €"
          alignment="right"
          [width]="130">
        </dxi-column>

        <dxi-column
          dataField="partner_pa_id_vezni"
          caption="Prijevoznik"
          [visible]="false"
        ></dxi-column>

        <dxi-column
          dataField="prijevoznik"
          caption="Prijevoznik"
          [minWidth]="180"
        ></dxi-column>

        <dxi-column
          dataField="pz_registracijavozila"
          caption="Registracija vozila"
          [width]="125"
        ></dxi-column>

        <dxi-column
          dataField="pz_status"
          caption="Status"
          [width]="100"
          alignment="center"
        ></dxi-column>

        <dxi-column cellTemplate="PDF" alignment="center" caption="PDF" width="70" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'PDF'">
            <div *ngIf="data.data.pz_status === 'Z' || data.data.pz_status === 'S'">
              <dx-button
                icon="pdffile"
                (onClick)="pdfOtpremnica(data)"
                [disabled]="pravaZaTrenutniPogled != 2"
              >
              </dx-button>
            </div>
          </div>
        </dxi-column>

        <dxi-column cellTemplate="zavrsi" caption="ZAVRŠI" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'zavrsi'">
            <div *ngIf="data.data.pz_status != 'S' && data.data.pz_status != 'Z'">
              <dx-button
                [disabled]="pravaZaTrenutniPogled != 2"
                text="Završi"
                (onClick)="zavrsiDokument(data)"
              >
              </dx-button>
            </div>
            <br />
          </div>
        </dxi-column>

        <dxi-column caption="Storniraj" cellTemplate="storniranje" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'storniranje'">
            <div *ngIf="data.data.pz_status === 'Z' && data.data.pz_program_kreiranja == 0 && data.data.partner_pa_id == '3283'"> <!-- PEKAR MLP D.O.O. -->
              <dx-button
                [disabled]="pravaZaTrenutniPogled != 2"
                hint="Storniraj"
                icon="close"
                (onClick)="stornirajDokument(data)"
              ></dx-button>
            </div>
          </div>
        </dxi-column>

        <dxo-master-detail
          [enabled]="false"
          template="detail"
        ></dxo-master-detail>

        <div *dxTemplate="let data of 'detail'">
          <p *ngIf="!stavke">Dohvaćanje stavki...</p>
          <p *ngIf="stavke.length === 0">Otpremnica nema stavki!</p>
          <div>
          <div>
            <div class="otpremnicaStavke">
              <dx-tree-list
                [dataSource]="stavke"
                [wordWrapEnabled]="true"
                keyExpr="ps_id"
                [showBorders]="true"
                (onCellPrepared)="onCellPrepared($event)"
                (onInitNewRow)="onInitNewRow($event)"
                (onEditingStart)="onEditingStart($event)"
                (onRowInserted)="dodajStavku($event)"
                (onRowUpdated)="urediStavku($event)"
                (onRowRemoved)="obrisiStavku($event)">
                
              <dxo-editing mode="popup" 
                [allowUpdating]="dozvoliUredivanje"
                [allowAdding]="dozvoliUredivanje"
                [allowDeleting]="dozvoliUredivanje">

                <dxo-popup                        
                  title="Stavke otpremnice"
                  [showTitle]="true"
                  [width]="500"
                  [height]="'auto'">
                </dxo-popup> 

                <dxo-form>
                  <dxi-item itemType="group" [colCount]="1" [colSpan]="2">
                    <dxi-item dataField="artikl_ar_id"></dxi-item>  
                    <dxi-item dataField="ps_izlaz"></dxi-item>                                        
                    <dxi-item dataField="ar_lot"></dxi-item>
                  </dxi-item>
                </dxo-form>

              </dxo-editing>
              
                <dxi-column
                  dataField="ar_sifra"
                  caption="Šifra"
                  [width]="120"
                  [allowEditing]="false">
                </dxi-column>
                <!-- u tablici prikazujem jedno (ar_naziv) a u formi za dodavanje/uredivanje drugo (artikl_ar_id) -->
                <dxi-column
                  dataField="ar_naziv"
                  caption="Proizvod"
                  [width]="300"
                  [allowEditing]="false">
                </dxi-column>
                <dxi-column
                  dataField="artikl_ar_id"
                  caption="Proizvod"
                  [width]="300"
                  [allowEditing]="true"
                  [visible]="false" [formItem]="{ visible: true }"
                  [editorOptions]="{ onItemClick: odabranArtikl, showClearButton: true, searchExpr: 'artiklsifranaziv' }">
                  <dxo-lookup
                    [dataSource]="sviArtikli_poslovnica"
                    valueExpr="ar_id"
                    displayExpr="artiklsifranaziv">
                  </dxo-lookup>
                </dxi-column>
                <dxi-column
                  dataField="ps_izlaz"
                  caption="Količina"
                  [width]="100">
                </dxi-column>
                <dxi-column
                  dataField="jedinicamjere_JM_SIFRA"
                  caption="Jed.mj."
                  [width]="80"
                  [allowEditing]="false">
                </dxi-column>
                <!-- u tablici prikazujem jedno a u formi za dodavanje/uredivanje drugo -->
                <!-- zato sto sviLotovi_artikla ovise tj. dohvacaju se i pune kad odaberemo artikl -->
                <dxi-column
                  dataField="ar_lot"
                  caption="LOT"
                  [width]="300"
                  [allowEditing]="true"
                  [visible]="false"
                  [formItem]="{ visible: true }"
                  [editorOptions]="{ value: artikl_lot, onItemClick: odabranLot }">
                  <dxo-lookup
                    [dataSource]="sviLotovi_artikla"
                    valueExpr="ar_lot"
                    displayExpr="ar_datum_ar_vazido_ar_lot_ar_lotstanje_spojeno">
                  </dxo-lookup>
                </dxi-column>
                <dxi-column
                  dataField="ar_lot"
                  caption="LOT"
                  [width]="100"
                  [formItem]="{ visible: false }">
                </dxi-column>
                <dxi-column
                  dataField="ps_izlazc"
                  caption="Cijena"
                  [width]="100"
                  [allowEditing]="false"><dxo-format type="fixedPoint" [precision]="3"></dxo-format>
                </dxi-column>
              </dx-tree-list>
            </div>
          </div>
        </div>

        <!-- <div *dxTemplate="let data of 'detail'">
          <p *ngIf="!stavke">Dohvaćanje stavki...</p>
          <p *ngIf="stavke.length === 0">Otpremnica nema stavki!</p>
          <div>
            <div class="otpremnicaStavke">
              <dx-data-grid
                [dataSource]="stavke"
                [wordWrapEnabled]="true"
                keyExpr="ps_id"
                [showColumnLines]="true"
                [showBorders]="true"
                (onRowUpdated)="urediStavku($event)"
                (onRowRemoved)="obrisiStavku($event)"
                [disabled]="pravaZaTrenutniPogled != 2"
              >
                <dxo-group-panel [visible]="true"></dxo-group-panel>

                <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>

                <dxo-editing
                  *ngIf="data.data.pz_status !== 'Z'"
                  mode="row"
                  [allowUpdating]="true"
                  [allowDeleting]="true"
                  [allowAdding]="true"
                ></dxo-editing>

                <dxi-column
                  dataField="ar_sifra"
                  caption="Šifra"
                  [width]="120"
                  [allowEditing]="false"
                ></dxi-column>

                <dxi-column
                  dataField="ar_naziv"
                  caption="Proizvod"
                  [width]="500"
                  [allowEditing]="false"
                ></dxi-column>

                <dxi-column
                  dataField="ar_lot"
                  caption="LOT"
                  [width]="120"
                  [allowEditing]="true"
                  [groupIndex]="0"
                ></dxi-column>

                <dxi-column
                  dataField="ps_izlaz"
                  caption="Količina"
                  [width]="120"
                  [allowEditing]="true"
                ></dxi-column>

                <dxi-column
                  dataField="br_kutija"
                  caption="Broj kutija"
                  [width]="120"
                  alignment="center"
                  [allowEditing]="false"
                ></dxi-column>

                <dxo-summary>
                  <dxi-group-item
                    column="ar_lot"
                    summaryType="count"
                    displayFormat="Ukupno paleta: {0}"
                  >
                  </dxi-group-item>
                </dxo-summary>

                <dxi-sort-by-group-summary-info
                  summaryItem="count"
                ></dxi-sort-by-group-summary-info>
              </dx-data-grid>
            </div>
          </div>
        </div> -->
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>

<!-- <dx-popup
  [width]="1000"
  [height]="'auto'"
  [showTitle]="true"
  title="Ručno upisivanje palete"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [(visible)]="popupAddPalleteVisible"
  [closeOnOutsideClick]="false"
>
  <div class="popup-form-wrapper">
    <div class="floating-placeholder">
      <dx-select-box
        [dataSource]="sviProizvodi"
        displayExpr="sifraNaziv"
        [(value)]="odabraniProizvod"
        placeholder="Proizvod"
        (onValueChanged)="onChangeProizvodId($event)"
        [searchEnabled]="true"
        [showClearButton]="true"
        required
      ></dx-select-box>
    </div>

    <div class="floating-placeholder">
      
      <dx-select-box
        [dataSource]="sviLotovi"
        displayExpr="lotBroj"
        valueExpr="lotBroj"
        [(value)]="odabraniLot"
        placeholder="LOT broj"
        (onValueChanged)="onChangeLot($event)"
        [searchEnabled]="true"
        [showClearButton]="true"
        required
      ></dx-select-box>
    </div>

    <!-- <div class="floating-placeholder">
      <dx-select-box
        [dataSource]="sviLotovi"
        displayExpr="lotBroj"
        valueExpr="id"
        [(value)]="lotBroj"
        placeholder="Lot broj"
        [searchEnabled]="true"
        [showClearButton]="true"
        (onValueChanged)="onChangeLot($event)"
        required
      ></dx-select-box>
    </div> -->

    <!-- <div class="floating-placeholder">
      <dx-text-box
        placeholder="LOT broj"
        [value]="lotBroj"
        (onValueChanged)="onChangeLot($event)"
        [showClearButton]="true"
        required
      ></dx-text-box>
    </div> -->

    <!-- <div class="floating-placeholder">
      <dx-text-box
        placeholder="Količina"
        [value]="kolicina"
        (onValueChanged)="onChangeKolicina($event)"
        required
      ></dx-text-box>
    </div> -->

    <!-- <div class="floating-placeholder">
      <dx-text-box
        placeholder="Broj kutija"
        [value]="brojKutija"
        (onValueChanged)="onChangeKutije($event)"
        required
      ></dx-text-box>
    </div> -->

    <!-- <dx-button
      [width]="'auto'"
      [height]="'auto'"
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="Dodaj"
      [disabled]="idProizvoda === '' || lotBroj === '' || brojKutija === ''"
      (onClick)="dodajStavku()"
    >
    </dx-button> -->

    <!-- <div class="floating-placeholder">
    <dx-select-box
        [dataSource]="admin"
        displayExpr="naziv"
        valueExpr="id"
        placeholder="Admin"
        [value]="adminStatus === 'Da' ? 1 : 0"
        (onValueChanged)="onChangeAdmin($event)">
    </dx-select-box>
  </div> -->
    <!-- <div class="floating-placeholder">
    <dx-select-box
        [dataSource]="vrsta"
        displayExpr="naziv"
        valueExpr="id"
        placeholder="Vrsta"
        [value]="vrstaStatus"
        (onValueChanged)="onChangeVrsta($event)">
    </dx-select-box>
  </div> -->

    <!-- <div class="floating-placeholder">
      <dx-select-box
          [dataSource]="radnaMjesta"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Radno mjesto"
          [value]="radnoMjesto"
          (onValueChanged)="onChangeRadnoMjesto($event)">
      </dx-select-box>
  </div> -->
    <!-- <div class="floating-placeholder">
      <dx-select-box
          [dataSource]="partneri"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Partner"
          [value]="partnerId"
          [searchEnabled]="true"
          [searchExpr]="'naziv'"
          (onValueChanged)="onChangePartner($event)">
      </dx-select-box>
  </div> -->
    <!-- <div class="floating-placeholder">
      <dx-select-box
          [dataSource]="poslovnice"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Poslovnica"
          [value]="poslovnicaId"
          [searchEnabled]="true"
          [searchExpr]="'naziv'"
          (onValueChanged)="onChangePoslovnica($event)">
      </dx-select-box>
  </div> -->
  <!-- </div> -->

  <!-- <div *dxTemplate="let data of 'naslovTablice'"></div>
  <dx-data-grid
    [dataSource]="stavkePalete"
    [showBorders]="false"
    [wordWrapEnabled]="true"
  >
    <dxi-column
      dataField="stavkePaleta"
      caption="Stavke"
      cellTemplate="templateStavke"
    ></dxi-column>
    <div *dxTemplate="let data of 'templateStavke'">
      <dx-check-box displayExpr="sgr_naziv" [value]="data.data.stavkePaleta">
      </dx-check-box>
    </div>
    <dxi-column dataField="sgr_naziv" caption="Naziv grupe"></dxi-column>
  </dx-data-grid> -->
<!-- </dx-popup> -->

<dx-popup
  title="{{naslov}}"
  [showTitle]="true"
  [width]="1000"
  [height]="'auto'"
  [closeOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="povezaniDokumentiPopup"
  [position]="{ my: 'center', at: 'center', of: window }"
>
  <dx-data-grid
    id="tablicaPovezaniDokumenti"
    [dataSource]="povezani_dokumenti"
    [showColumnLines]="true"
    [wordWrapEnabled]="true"
    [showBorders]="false"
  >
    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
    <dxi-column
      dataField="pz_broj"
      caption="Broj"
      [width]="100"
      alignment="right"
    >
    </dxi-column>
    <dxi-column dataField="DV_NAZIV" caption="Vrsta" alignment="center">
    </dxi-column>
    <dxi-column
      dataField="pz_datum"
      dataType="date"
      caption="Datum"
      [width]="130"
      alignment="center"
    >
    </dxi-column>
    <dxi-column dataField="fi_naziv" caption="Firma"> </dxi-column>
    <dxi-column dataField="po_naziv" caption="Naziv skladišta"> </dxi-column>
  </dx-data-grid>
  <br />
  <dxi-item class="btn_group">
    <dx-button
      stylingMode="contained"
      [height]="40"
      [width]="120"
      type="success"
      (onClick)="uredu()"
      >UREDU</dx-button
    ><br /><br />
  </dxi-item>
</dx-popup>
